import useBuildVariantProps from '../../../../modules/theme/useBuildVariantProps';
import { DateInputProps } from './DateInput.types';
import { Icon } from '../../../atoms';
import { useCallback, useRef, useState } from 'react';
import { Instance } from 'flatpickr/dist/types/instance';

const usePresenter = (props: DateInputProps) => {
  const {
    value,
    onValueChange,
    disabled,
    invalid,
    required,
    noCalendar,
    enableTime,
    onReady,
  } = props;

  const [readOnly, setReadOnly] = useState(false);
  const isTimePickerOnly = noCalendar && enableTime;

  // Store the Flatpickr instance for programmatic control
  const instanceRef = useRef<Instance | null>(null);

  const onInputBlur = useCallback(
    (event: React.FocusEvent<HTMLInputElement>) => {
      const inputValue = event.target.value.trim();
      onValueChange?.(inputValue);
    },
    [onValueChange]
  );

  const inputLeadingIcon = isTimePickerOnly && <Icon icon='Schedule' style='Outlined' size='Small' />;

  const inputVariantProps = useBuildVariantProps(
    'date-input',
    {},
    { disabled, required, invalid }
  );

  const handleInputReadOnlyState = useCallback(
    (value: boolean) => {
      setReadOnly(value);
    },
    []
  );

  // Handle onReady callback to capture the Flatpickr instance
  const handleReady = useCallback(
    (dates: Date[], dateStr: string, calendarInstance: Instance) => {
      instanceRef.current = calendarInstance;

      onReady?.(dates, dateStr, calendarInstance);
    },
    [onReady]
  );

  // Handle calendar icon click to open the date picker
  const handleCalendarIconClick = useCallback(() => {
    if (instanceRef.current && !disabled) {
      instanceRef.current.toggle();
    }
  }, [disabled]);

  return {
    invalid,
    onInputBlur,
    inputLeadingIcon,
    readOnly,
    inputVariantProps,
    value,
    isTimePickerOnly,
    handleInputReadOnlyState,
    handleReady,
    handleCalendarIconClick,
  };
}

export default usePresenter;